<div [ngStyle]="ngStyle()">
  <!--  if you add px to svg-width or svg-height vars will not work ex: var(--svg-width)px -->
  <svg
    [style]="{ width: 'var(--svg-width)', height: 'var(--svg-height)' }"
    [attr.fill]="'var(--fill-color)'"
    [attr.stroke]="'var(--stroke-color)'"
    [attr.strokeWidth]="strokeWidth()"
    [attr.preserveAspectRatio]="'none'">
    <use
      [style]="{ width: 'var(--svg-width)', height: 'var(--svg-height)' }"
      [attr.xlink:href]="svgIcon()"
      [attr.stroke]="'var(--stroke-color)'"
      [attr.strokeWidth]="strokeWidth()"></use>
  </svg>
</div>
